import React from 'react';
import { Trans, t } from '@lingui/macro';
import { ChartEntry, ChartVariants } from '../Charts.types';
import * as Styled from '../Charts.styled';

type ChartListDetailsProps = {
    chartEntry: ChartEntry;
    type: ChartVariants;
};

export const ChartListDetails: React.FC<ChartListDetailsProps> = ({
    chartEntry,
    type,
}) => {
    let subheading;

    switch (type) {
        case ChartVariants.Labels:
            subheading = <Trans>{chartEntry?.subItemsCount} packs</Trans>;
            break;
        case ChartVariants.Packs:
            subheading = <Trans>by {chartEntry.artistName}</Trans>;
            break;
        case ChartVariants.LandrTopPacks:
            subheading = <Trans>{chartEntry?.subItemsCount} samples</Trans>;
            break;
    }

    return (
        <Styled.DetailsContainer>
            <Styled.DetailsHeadingWrapper>
                <Styled.DetailsHeading isNew={chartEntry.isNew}>
                    {chartEntry.name}
                </Styled.DetailsHeading>
                {chartEntry.isNew && (
                    <Styled.NewBadge
                        variant="secondary"
                        isRounded
                        content={t`New`}
                        ml="xs"
                        size="sm"
                    />
                )}
            </Styled.DetailsHeadingWrapper>
            <Styled.DetailsSubheading contrast="low" nbOfLines={1}>
                {subheading}
            </Styled.DetailsSubheading>
        </Styled.DetailsContainer>
    );
};
